import { render, staticRenderFns } from "./FlagsManage.vue?vue&type=template&id=25d0f126&scoped=true"
import script from "./FlagsManage.vue?vue&type=script&lang=js"
export * from "./FlagsManage.vue?vue&type=script&lang=js"
import style0 from "./FlagsManage.vue?vue&type=style&index=0&id=25d0f126&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d0f126",
  null
  
)

export default component.exports